module.exports = __webpack_public_path__ + "img/upload-cloud-02.64c28818.svg";